import { render, staticRenderFns } from "./administrativeSanction.vue?vue&type=template&id=916ab53c&scoped=true&"
import script from "./administrativeSanction.vue?vue&type=script&lang=js&"
export * from "./administrativeSanction.vue?vue&type=script&lang=js&"
import style0 from "./administrativeSanction.vue?vue&type=style&index=0&id=916ab53c&prod&scoped=true&lang=css&"
import style1 from "./administrativeSanction.vue?vue&type=style&index=1&id=916ab53c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916ab53c",
  null
  
)

export default component.exports